// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebarWrapper {
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 40;
    display: flex;
    height: 100vh;
    width: 100%;
    flex-shrink: 0;
    flex-direction: column;
    overflow-y: scroll;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
    transition-property: all;
    transition-duration: 200ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@media (min-width: 768px) {
    .sidebarWrapper {
        position: static;
        left: auto;
        top: auto;
        width: 16rem;
        overflow-y: auto;
    }
}
@media (min-width: 1024px) {
    .sidebarWrapper {
        display: block;
    }
}
.navWrapper {
    display: flex;
    height: 100%;
    flex-direction: column;
    overflow-y: scroll;
}

.navWrapper::-webkit-scrollbar {
    display: none;
}

.navWrapper::-webkit-scrollbar-track {
    border-radius: 10px;
}

.navWrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
}

#menu li a.active,  li.active {
    --tw-bg-opacity: 1;
    background-color: rgb(125 211 252 / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: rgb(14 165 233 / var(--tw-text-opacity));
    border-radius: 0.375rem !important;
    color: rgb(20 83 45 / var(--tw-text-opacity)) !important;
}

#menu ul > li > a.link {
    font-weight: 400;
    position: relative;
}

#menu ul > li > a.link:last-child:before {
    height: 1em;
    bottom: auto;
}

#menu ul > li > a.link:before{
    position: absolute;
    top: 0;
    bottom: 0;
    left: -0.5em;
    display: block;
    width: 0;
    border-left: 1px dashed #777;
    content: "";
}
#menu ul > li > a.link:after{
    position: absolute;
    top: 1em;
    left: -0.5em;
    display: block;
    height: 0.5em;
    width: 1em;
    border-bottom: 1px dashed #777;
    border-left: 1px dashed #777;
    border-radius: 0 0 0 0.3em;
    content: '';
}

#menu ul > li > a.active {
    background-color: transparent;
    font-weight: 600;
}

li > a > svg {
    height: 1rem;
    width: 1rem;
}

.group:hover li > a > svg {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
}

li > a.active > svg,  li.active > svg {
    --tw-text-opacity: 1;
    color: rgb(3 105 161 / var(--tw-text-opacity));
}

#menu .link,  button.link {
    display: flex;
    cursor: pointer;
    align-items: center;
    gap: 1.5rem;
    border-radius: 0.125rem;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity));
}

#menu .link:hover {
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity));
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/sidebar.css"],"names":[],"mappings":"AACI;IAAA,kBAAkN;IAAlN,SAAkN;IAAlN,QAAkN;IAAlN,WAAkN;IAAlN,aAAkN;IAAlN,aAAkN;IAAlN,WAAkN;IAAlN,cAAkN;IAAlN,sBAAkN;IAAlN,kBAAkN;IAAlN,kBAAkN;IAAlN,yDAAkN;IAAlN,wBAAkN;IAAlN,0BAAkN;IAAlN;AAAkN;AAAlN;IAAA;QAAA,gBAAkN;QAAlN,UAAkN;QAAlN,SAAkN;QAAlN,YAAkN;QAAlN;IAAkN;AAAA;AAAlN;IAAA;QAAA;IAAkN;AAAA;AAGlN;IAAA,aAA6C;IAA7C,YAA6C;IAA7C,sBAA6C;IAA7C;AAA6C;;AAGjD;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAGI;IAAA,kBAAyC;IAAzC,yDAAyC;IAAzC,oBAAyC;IAAzC,+CAAyC;IACzC,kCAAkC;IAClC;AAFyC;;AAMzC;IAAA,gBAAkB;IAClB;AADkB;;AAItB;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,4BAA4B;IAC5B,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,4BAA4B;IAC5B,0BAA0B;IAC1B,WAAW;AACf;;AAGI;IAAA,6BAAmC;IAAnC;AAAmC;;AAInC;IAAA,YAAuC;IAAvC;AAAuC;;AAAvC;IAAA,oBAAuC;IAAvC;AAAuC;;AAIvC;IAAA,oBAAmB;IAAnB;AAAmB;;AAInB;IAAA,aAAuG;IAAvG,eAAuG;IAAvG,mBAAuG;IAAvG,WAAuG;IAAvG,uBAAuG;IAAvG,kBAAuG;IAAvG,mBAAuG;IAAvG,mBAAuG;IAAvG,sBAAuG;IAAvG,mBAAuG;IAAvG,oBAAuG;IAAvG,gBAAuG;IAAvG,oBAAuG;IAAvG;AAAuG;;AAIvG;IAAA,oBAAqB;IAArB;AAAqB","sourcesContent":[".sidebarWrapper{\n    @apply lg:block absolute flex flex-col left-0 top-0 md:static md:left-auto md:top-auto h-screen overflow-y-scroll md:overflow-y-auto w-full md:w-64 shrink-0 transition-all duration-200 ease-in-out z-40 bg-white;\n}\n.navWrapper{\n    @apply flex flex-col h-full overflow-y-scroll;\n}\n\n.navWrapper::-webkit-scrollbar {\n    display: none;\n}\n\n.navWrapper::-webkit-scrollbar-track {\n    border-radius: 10px;\n}\n\n.navWrapper::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n}\n\n#menu li a.active, li.active {\n    @apply text-sky-500 bg-sky-300 rounded-md;\n    border-radius: 0.375rem !important;\n    color: rgb(20 83 45 / var(--tw-text-opacity)) !important;\n}\n\n#menu ul > li > a.link{\n    @apply font-normal;\n    position: relative;\n}\n\n#menu ul > li > a.link:last-child:before {\n    height: 1em;\n    bottom: auto;\n}\n\n#menu ul > li > a.link:before{\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: -0.5em;\n    display: block;\n    width: 0;\n    border-left: 1px dashed #777;\n    content: \"\";\n}\n#menu ul > li > a.link:after{\n    position: absolute;\n    top: 1em;\n    left: -0.5em;\n    display: block;\n    height: 0.5em;\n    width: 1em;\n    border-bottom: 1px dashed #777;\n    border-left: 1px dashed #777;\n    border-radius: 0 0 0 0.3em;\n    content: '';\n}\n\n#menu ul > li > a.active {\n    @apply bg-transparent font-semibold;\n}\n\nli > a > svg {\n    @apply w-4 h-4 group-hover:text-gray-400\n}\n\nli > a.active > svg, li.active > svg {\n    @apply text-sky-700;\n}\n\n#menu .link, button.link {\n    @apply flex items-center px-4 py-2 text-sm text-slate-500 font-semibold rounded-sm gap-6 cursor-pointer;\n}\n\n#menu .link:hover{\n    @apply text-slate-700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
